export var DATE_FORMAT = 'DD.MM.YYYY';
//# sourceMappingURL=constants.js.map